<template>
  <div class="mobile-number-page">
    <center-spinner :loading="loading" />

    <div class="auth-content">
      <div>
        <img
          src="../../../assets/img/new_app_logo.png"
          class="logo"
        >
      </div>

      <h1 class="header-style">
        Passcode Reset
      </h1>

      <div
        v-if="verificationSuccess"
        class="success-message-style"
      >
        <p class="success-style">
          <v-icon
            color="#2E7D32"
            size="30"
          >
            mdi-check-all
          </v-icon>
          <br><br>
          {{ verificationSuccessMessage }}
        </p>
      </div>

      <div
        v-if="verificationFailed"
        class="fail-message-style"
      >
        <p class="fail-style">
          <v-icon
            color="#C62828"
            size="30"
          >
            mdi-alert
          </v-icon>
          <br><br>
          {{ verificationFailedMessage }}
        </p>
      </div>

      <p class="subheader-style">
        Please enter the mobile number you used to register
      </p>

      <v-form ref="form">
        <vue-phone-number-input
          v-model="phone"
          class="mb-4"
          :default-country-code="'AU'"
          @update="onPhoneUpdate"
        />

        <v-btn
          class="mt-2 btn-style confirm-button"
          elevation="0"
          @click="confirmMobile"
        >
          Confirm
        </v-btn>

        <v-btn
          class="mt-2 btn-style cancel-button"
          color="#E6E6E6"
          elevation="0"
          @click="cancelPasscodeReset"
        >
          Cancel
        </v-btn>
      </v-form>
    </div>
  </div>
</template>

<script>
import Constants from 'src/constants';
import SpinnerCentre from '../../components/SpinnerCentre.vue';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
  name: 'MobileNumberPage',

  components: {
    VuePhoneNumberInput,
    'center-spinner': SpinnerCentre,
  },

  data () {
    return {
      loading: false,
      phone: null,
      nationalNumber: null,
      verificationSuccess: false,
      verificationFailed: false,
      verificationSuccessMessage: '',
      verificationFailedMessage: '',
    };
  },

  methods: {
    onPhoneUpdate (data) {
      if (data && data.isValid) {
        this.nationalNumber = data.nationalNumber;
      } else {
        this.nationalNumber = null;
      }
    },

    async confirmMobile () {
      if (!this.nationalNumber) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Please enter a valid number',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }

      this.loading = true;
      this.verificationFailed = false;
      this.verificationSuccess = false;

      try {
        await this.$store
          .dispatch('passcodereset/confirmMobile', {
            phone_number: this.nationalNumber,
          })
          .then(() => {
            this.$router.push({
              name: 'Link Validation',
              params: { mobileNumber: this.nationalNumber },
            });
          });
        // this.verificationSuccess = true;
        // this.verificationSuccessMessage =
        //  'You will shortly receive a text message with instructions to reset your passcode.';
      } catch (error) {
        this.verificationFailed = true;

        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          this.verificationFailedMessage = error.response.data.message;
        } else {
          this.verificationFailedMessage = 'Verification failed';
        }
      }

      this.loading = false;
    },

    cancelPasscodeReset () {
      this.$router.push({ name: 'Login' });
    },
  },
};
</script>

<style scoped>
.confirm-button {
  font-size: 15px;
  border-radius: 30px;
  background-color: #000 !important;
}

.cancel-button {
  font-size: 15px;
  border-radius: 30px;
}

.logo {
  width: 50px;
  margin-bottom: 10px;
}

::v-deep(.vue-phone-number-input .country-selector__list) {
  background-color: #ffffff !important;
}

::v-deep(.vue-phone-number-input .country-selector__list__item) {
  color: #000000 !important;
}
</style>
